/**
 * Design Tokens - Layout
 * Exported from Figma: Enersee Platform 2.0 - _Foundation_DesignSystem
 *
 * Layout constraints and widths.
 */

export const layoutTokens = {
  width: {
    '2xl': '1024px', // width-2xl
  },
  maxWidth: {
    paragraph: '720px', // paragraph-max-width
  },
} as const;

export type LayoutTokens = typeof layoutTokens;
